import axios from 'axios';
import { ProductListingModel } from '../models/ProductListingModel';

const API_URL = process.env.REACT_APP_API_URL;
const PRODUCT_LISTING_URL = `${API_URL}/api/b2b/product-listing/`;

interface ListProductListingsParams {
  distributor?: number;
  country?: string;
}
export async function listProductListings({
  distributor,
  country,
}: ListProductListingsParams): Promise<{ data: ProductListingModel[] }> {
  return axios.get(PRODUCT_LISTING_URL, {
    params: {
      distributor,
      country,
    },
  });
}

interface CreateProductListingParams {
  id?: number;
  country: string;
  distributor?: number;
  product: number;
  pvf_unit: number;
  pvpr?: number | null;
  units_mult_factor: number;
  is_active: boolean;
}

export function updateProductListing(
  productListing: CreateProductListingParams
): Promise<{ data: ProductListingModel }> {
  const {
    distributor,
    product,
    pvf_unit,
    pvpr,
    country,
    units_mult_factor,
    is_active,
  } = productListing;
  return axios.patch(`${PRODUCT_LISTING_URL}${productListing?.id}/`, {
    distributor,
    product,
    pvf_unit,
    pvpr,
    country,
    units_mult_factor,
    is_active,
  });
}

export async function downloadProductListingExcel({
  distributor,
  country,
}: ListProductListingsParams): Promise<Blob> {
  const response = await axios.get(`${PRODUCT_LISTING_URL}download-excel/`, {
    params: { distributor, country },
    responseType: 'blob',
  });
  return response.data;
}

export function createProductListing({
  distributor,
  product,
  pvf_unit,
  pvpr,
  units_mult_factor,
  country,
  is_active = true,
}: CreateProductListingParams): Promise<{ data: ProductListingModel }> {
  return axios.post(PRODUCT_LISTING_URL, {
    distributor,
    product,
    pvf_unit,
    pvpr,
    country,
    units_mult_factor,
    is_active,
  });
}
